export default [
    {
        path: '/aim',
        name: '宗旨',
        component: () => import("../page/about/aim/index"),
    },
    {
        path: '/contribute',
        name: '公益捐助',
        component: () => import('../page/about/contribute/index')
    }
]
